import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

interface DegradedBannerProps {
  /** Names of platforms that reported errors during the last audit */
  degradedPlatforms: string[];
  /** Called when the user dismisses the banner */
  onDismiss: () => void;
}

/**
 * DegradedBanner — persistent dismissable warning shown when one or more platforms
 * returned errors during the last audit run, meaning data may be incomplete.
 *
 * Renders nothing when degradedPlatforms is empty.
 */
export default function DegradedBanner({ degradedPlatforms, onDismiss }: DegradedBannerProps) {
  if (degradedPlatforms.length === 0) {
    return null;
  }

  const platformList = degradedPlatforms.join(', ');

  return (
    <Alert
      severity="warning"
      sx={{ mb: 2 }}
      action={
        <IconButton
          aria-label="dismiss degraded platform warning"
          color="inherit"
          size="small"
          onClick={onDismiss}
        >
          <CloseIcon fontSize="inherit" />
        </IconButton>
      }
    >
      Data may be incomplete. The following platforms reported errors: {platformList}.
    </Alert>
  );
}
